import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import './FlowLayout.css';

function ContactPage() {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        const formData = { name, email, message };

        try {
            const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT || 'http://localhost:8000';
            const response = await fetch(`${API_ENDPOINT}/api/contact/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            });

            if (response.ok) {
                setSuccess(true);
            } else {
                setError('Failed to send message. Please try again.');
            }
        } catch (err) {
            console.error('Error submitting form:', err);
            setError('An error occurred. Please try again later.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="flow-page">
            <Helmet>
                <title>Contact Us</title>
                <meta name="description" content="Contact Easy Global Entry for support with your Global Entry appointment booking. We are here to help you expedite your interview." />
                <link rel="canonical" href="https://www.easyglobalentry.com/contact" />
            </Helmet>

            <div className="flow-layout" style={{ marginTop: '80px', marginBottom: '80px' }}>
                {/* Left column */}
                <div className="flow-left">
                    <h1 className="flow-heading">
                        Struggling to book an interview?
                    </h1>
                    <p className="flow-subtitle">
                        Try our Autobook service and we guarantee you will get an interview within 2 weeks or your money back! 
                        Reach out to us below and our support team will help you get started.
                    </p>

                    <div className="info-card info-card--subtle" style={{ marginTop: '48px' }}>
                        <h3 className="info-card__title">Support Hours</h3>
                        <p className="info-card__text">
                            Our team is available Monday – Friday, 9:00 AM – 5:00 PM (PST). 
                            We aim to respond to all inquiries within 24 hours.
                        </p>
                    </div>
                </div>

                {/* Right column */}
                <div className="flow-right">
                    <div className="panel-card">
                        {success ? (
                            <div style={{ textAlign: 'center', padding: '40px 20px' }}>
                                <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '24px' }}>
                                    <svg viewBox="0 0 24 24" fill="none" stroke="#2E8540" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" width="64" height="64">
                                        <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                                        <polyline points="22 4 12 14.01 9 11.01" />
                                    </svg>
                                </div>
                                <h2 style={{ fontFamily: 'Lato, sans-serif', fontSize: '24px', fontWeight: '800', color: '#112E51', marginBottom: '16px' }}>
                                    Message Sent
                                </h2>
                                <p style={{ fontFamily: 'Lato, sans-serif', fontSize: '15px', color: '#5B7083', lineHeight: '1.5' }}>
                                    Thank you for reaching out! We have received your message and will get back to you shortly.
                                </p>
                            </div>
                        ) : (
                            <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                                <div>
                                    <label className="flow-label" htmlFor="contact-name">Name</label>
                                    <input
                                        id="contact-name"
                                        className="connect-input"
                                        type="text"
                                        placeholder="Your full name"
                                        value={name}
                                        onChange={(e) => setName(e.target.value)}
                                        required
                                        disabled={loading}
                                    />
                                </div>

                                <div>
                                    <label className="flow-label" htmlFor="contact-email">Email Address</label>
                                    <input
                                        id="contact-email"
                                        className="connect-input"
                                        type="email"
                                        placeholder="you@example.com"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        required
                                        disabled={loading}
                                    />
                                </div>

                                <div>
                                    <label className="flow-label" htmlFor="contact-message">Message</label>
                                    <textarea
                                        id="contact-message"
                                        className="connect-input"
                                        placeholder="How can we help you?"
                                        rows="5"
                                        value={message}
                                        onChange={(e) => setMessage(e.target.value)}
                                        required
                                        disabled={loading}
                                        style={{ resize: 'vertical', minHeight: '120px' }}
                                    />
                                </div>

                                {error && (
                                    <div style={{ color: '#ef4444', fontSize: '14px', fontFamily: 'Lato, sans-serif' }}>
                                        {error}
                                    </div>
                                )}

                                <button
                                    className="flow-btn-primary"
                                    type="submit"
                                    disabled={loading || !name || !email || !message}
                                    style={{ width: '100%', marginTop: '8px' }}
                                >
                                    {loading ? 'Sending...' : 'Send Message'}
                                </button>
                            </form>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ContactPage;
